export const formatClaimNumber = (claimNumber, tpa) => {
  if (tpa === 'Branch Claims') {
    return claimNumber.split('-')[0];
  }
  return claimNumber;
};
